export const svgIcon = {
  fontSizeSmall: {
    height: '15px',
    paddingRight: '9px'
  }
};